import { 
  GETBILLERTANDCBYTYPE, 
  ADDBILLERTANDC, 
  UPDATEBILLERTANDC 
} from "../../utils/api";
import axios from "../../utils/axios";


export const getBillerTAndCByType = async (type) => {
  const res = await axios.post(GETBILLERTANDCBYTYPE, {type});
  return res;
};


export const addBillerTAndC = async (payload) => {
  const res = await axios.post(ADDBILLERTANDC, payload);
  return res;
};


export const updateBillerTAndC = async (payload) => {
  const res = await axios.post(UPDATEBILLERTANDC, payload);
  return res;
};
